var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { RowInset } from "./subcomponents";
import { FieldValue } from "../subcomponents";
var Address = function (_a) {
    var _b;
    var data = _a.data;
    var address = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.mailingAddress;
    if (!address) {
        return null;
    }
    return (_jsx(RowInset, __assign({ top: "medium", bottom: "medium", "data-private": true }, { children: _jsxs(FieldValue, { children: [address["cipher.addressLine1"], _jsxs("div", { children: [address["cipher.addressLine2"], " "] }), _jsx("div", { children: "".concat(address["cipher.city"], ", ").concat(address["cipher.state"], " ").concat(address["cipher.zipCode"]) })] }) })));
};
export default Address;
